import throttle from 'lodash/throttle';

export default class Menu {
  constructor() {
    this.menu = document.querySelector('.menu');

    this.showPanel = this.showPanel.bind(this);
    this.showOverlay = this.showOverlay.bind(this);
    this.hideOverlay = this.hideOverlay.bind(this);

    this.init();
  }

  init() {
    if (!this.menu) return;
    this.getElements();
    this.bindEvents();
  }

  getElements() {
    this.panel = this.menu.querySelector('.menu__panel');
    this.overlay = this.menu.querySelector('.menu__overlay');
    this.headerTrigger = document.querySelector('.header__toggle');
    this.panelTrigger = document.querySelector('.menu__button--trigger');
    this.closeTrigger = document.querySelector('.menu__close');
  }

  bindEvents() {
    window.addEventListener('scroll', throttle(this.showPanel, 100));
    this.headerTrigger.addEventListener('click', this.showOverlay);
    this.panelTrigger.addEventListener('click', this.showOverlay);
    this.closeTrigger.addEventListener('click', this.hideOverlay);
  }

  showPanel() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.panel.classList.toggle('is-visible', scrollTop > 300);
  }

  showOverlay(e) {
    e.preventDefault();
    this.scrollOff();
    this.overlay.classList.add('is-visible');
  }

  hideOverlay(e) {
    e.preventDefault();
    this.scrollOn();
    this.overlay.classList.remove('is-visible');
  }

  scrollOff() {
    document.body.classList.add('scroll-off');
  }

  scrollOn() {
    document.body.classList.remove('scroll-off');
  }
};